// CustomEvent polyfill for IE9+
(function () {

    if ( typeof window.CustomEvent === "function" ) return false;

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
        }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'marketoForm', {
            bindings: {
                content:    '<',
            },
            templateUrl:    'app/views/partials/content/form.html',
            controller:     MarketoFormController,
            controllerAs:   'vm',

            renderingOptions: {
                'form': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    wrapStart:  '<div class="centraliser">',
                    wrapEnd:    '</div>',
                    classes: [],
                }
            }
        });

        /*
        * Whenever a selector is dynamically added, enhance it!
        */
        function watchForDynamicSelectors( formManager ){
            formManager.registerMutationHandler( function( nodeList ) {
                var addedSelectorElements = angular.element( nodeList ).find( 'select' );
                if ( addedSelectorElements.length > 0 ) initEnhancedSelector( addedSelectorElements );
            });
        }

        function initEnhancedSelector( selectorDomElements ) {
            var selectorElements = angular.element( selectorDomElements );
            selectorElements.select2( {
                template:           'select2',
                dropdownAutoWidth:  true,
            });

            /*
            * Replaces buggy jQuery Custom Event for browser's native Event
            * that gets captured by Marketo Event Listeners properly.
            */
            selectorElements.on( 'change', function( $event ) {
                if ( !$event.hasOwnProperty( 'originalEvent' )) {
                    $event.stopPropagation();
                    $event.preventDefault();
                    $event.target.dispatchEvent( new CustomEvent( 'change', { bubbles: true }));
                    return false;
                }

                return $event;
            });
        }



        /**
         * @param {ICompileService} $compile
         * @param {IScope} $scope
         * @param {IElement} $element
         * @param {MarketoForms} MarketoForms
         * @param {LoggerFactory} LoggerFactory
         */
        function MarketoFormController(
            $compile,
            $scope,
            $element,
            MarketoForms,
            LoggerFactory
        ){

            // Helper members.

            /** @type {angular.IController} */
            var vm = this;

            var formInstance;

            /** @type {Logger} */
            var logger = LoggerFactory.createLogger( 'DegreeOverviewController', false );


            /** @constructor */
            vm.$onInit = function() {
                MarketoForms.initForm( vm.content.id, $element[ 0 ].querySelector( '.form-container' ), {
                    envType: vm.content.envType,
                    customSuccessHtml: vm.content.sucessHtml,
                    customHtmlTail: vm.content.privacyHtml,
                }).then( function( form ) {
                    // 'form' is instance of 'Form' as described in http://developers.marketo.com/javascript-api/forms/api-reference/
                    formInstance    = form;
                    var formElement = angular.element( form.getFormElem() );

                    initEnhancedSelector( formElement.find( 'select' ) );
                    watchForDynamicSelectors( form.managerInstance );

                    angulariseTooltips( angular.element( formElement.find( '[data-tooltip]' )));
                }).catch(function( err ) {
                    logger.error( 'Marketo form ID %s could not be enhanced properly due to unexpected errors.', vm.content.id, err );
                });
            }


            vm.$onDestroy = function() {
                if ( formInstance ) formInstance.destroy();
            }


            function angulariseTooltips( tooltipifiedElements ) {
                // Must `clone -> add directive via attribute -> replace` to avoid inifinite loop.
                for ( var i = 0; i < tooltipifiedElements.length; i++ ) {
                    var tooltipifiedElement = angular.element( tooltipifiedElements[ i ]);
                    var enhancedTooltipifiedElement = tooltipifiedElement.clone();

                    enhancedTooltipifiedElement[0].setAttribute( 'tooltipify', '' );

                    var adjacentLabel = tooltipifiedElement.parent( '.mktoLabel' );

                    enhancedTooltipifiedElement = $compile( enhancedTooltipifiedElement )( $scope );
                    tooltipifiedElement.replaceWith( enhancedTooltipifiedElement );

                    if ( adjacentLabel ) {
                        // Prevent <label> from reacting to the 'tap' (click) on the tooltip.
                        adjacentLabel.bind( 'click', function( $event ) {
                            if ( $event.target == angular.element(this).children( '[data-tooltip]' )[0] ) {
                                $event.preventDefault();
                                $event.stopPropagation();
                            }
                        });
                    }
                }
            }
        }


        MarketoFormController.$inject = [ '$compile', '$scope', '$element', 'MarketoForms', 'LoggerFactory' ];
})();
